import store from '../store';
import * as types from '../actions/loading-actions';

class LoadingApi {

	/**
	 * shows loading
	 */
	static showLoading(){
		store.dispatch({
			type: types.SHOW_LOADING
		});
	}

	/**
	 * hides loading
	 */
	static hideLoading(){
		store.dispatch({
			type: types.HIDE_LOADING
		});
	}
}

export default LoadingApi;


// WEBPACK FOOTER //
// ./src/api/loading-api.js